@use 'sass:math';
@use '../../scss/utility/functions' as utility;
@use './toggle-vars';

$_toggle-width: calc(var(--toggle-padding-inline-start) + var(--toggle-inner-size) + var(--toggle-padding-inline-end));
$_toggle-height: calc(var(--toggle-padding-block-start) + var(--toggle-inner-size) + var(--toggle-padding-block-end));

:host {
  @include toggle-vars.wb-toggle-vars;

  outline: none;
  display: block;
}

:host(:hover:not([disabled])) {
  @include toggle-vars.wb-toggle-hover-vars;
}

:host(:focus-within) {
  @include toggle-vars.wb-toggle-focus-vars;
  label:before {
    outline: var(--toggle-border-weight) solid var(--toggle-border-ring-color);
    outline-offset: 1px;
  }
}

input:active ~ label {
  @include toggle-vars.wb-toggle-active-vars;
}

input:checked ~ label {
  @include toggle-vars.wb-toggle-on-vars;
}

:host(:not([disabled]):hover) input:checked ~ label {
  @include toggle-vars.wb-toggle-on-hover-vars;
}

:host(:focus-within) input:checked ~ label {
  @include toggle-vars.wb-toggle-on-focus-vars;
}

input:checked:active ~ label {
  @include toggle-vars.wb-toggle-on-active-vars;
}

:host([error]) {
  @include toggle-vars.wb-toggle-error-vars;
}

:host([error]:hover:not([disabled])) {
  @include toggle-vars.wb-toggle-error-hover-vars;
}

:host([error]:focus-within) {
  @include toggle-vars.wb-toggle-error-focus-vars;
}

:host([error]) input:active ~ label {
  @include toggle-vars.wb-toggle-error-active-vars;
}

:host([error]) input:checked ~ label {
  @include toggle-vars.wb-toggle-on-error-vars;
}

:host([error]:hover:not([disabled])) input:checked ~ label {
  @include toggle-vars.wb-toggle-on-error-hover-vars;
}

:host([error]:focus-within) input:checked ~ label {
  @include toggle-vars.wb-toggle-on-error-focus-vars;
}

:host([error]) input:checked:active ~ label {
  @include toggle-vars.wb-toggle-on-error-active-vars;
}

:host([is-rtl]) {
  input:checked + label::after {
    transform: translate3d(-20px, 0, 0);
  }
}

:host([disabled]) {
  label {
    cursor: not-allowed;
    pointer-events: none;

    .wb-text,
    &::before {
      opacity: var(--toggle-opacity-disabled);
    }

    &::after,
    &::before {
      cursor: not-allowed;
    }
  }

  input {
    cursor: not-allowed;
  }
}

.container {
  position: relative;
  display: inline-block;
}

input {
  display: none;
}

label {
  display: inline-block;
  color: var(--toggle-text-color);
  padding-inline-start: calc(#{$_toggle-width} + var(--toggle-gap));
  position: relative;
  cursor: pointer;

  min-height: $_toggle-height;

  &::before,
  &::after {
    content: '';
    display: block;
    position: absolute;
    cursor: pointer;
  }

  &::before {
    width: $_toggle-width;
    height: $_toggle-height;
    box-sizing: border-box;
    inset: 0;
    background-color: var(--toggle-background-color);
    border: var(--toggle-border-weight) solid var(--toggle-border-color);
    border-radius: var(--toggle-border-radius);
  }

  &::after {
    content: '';
    width: var(--toggle-inner-size);
    height: var(--toggle-inner-size);
    inset-block-start: 0;
    inset-inline-start: 0;
    background-color: var(--toggle-inner-color);
    transition: all 0.3s var(--wb-move);
    margin: var(--toggle-padding-block-start) 0 var(--toggle-padding-block-end);
    border-radius: var(--toggle-inner-radius);
    transform: translate3d(var(--toggle-padding-inline-start), 0, 0);
  }
}

input,
label {
  -webkit-tap-highlight-color: transparent;
}

::slotted(.wb-control-hint),
::slotted(.wb-control-error) {
  margin-block-start: var(--toggle-text-gap);
}

::slotted(.wb-control-hint) {
  color: var(--toggle-hint-text-color);
}
